import { replaceRoute } from '@/router';

export function showCreditsOffer(source: string): void {
  replaceRoute('paymentPurchaseCredits', { source });
}
